import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { AccountRequest, RequirementIntake, ViewService } from 'api';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { submit } from '@angular/forms/signals';
import { firstValueFrom } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { DialogComponent } from 'common/dialog/dialog.component';
import { DialogHeaderTitleDirective } from 'common/dialog/dialog-slots.directive';
import { CardButtonsComponent } from 'common/card/buttons/card-buttons.component';
import { ButtonDirective } from 'common/button/button.directive';

@Component({
  selector: 'comp-request-access',
  imports: [
    MatDialogClose,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatProgressSpinner,
    DialogComponent,
    DialogHeaderTitleDirective,
    CardButtonsComponent,
    ButtonDirective,
  ],
  templateUrl: 'account-request.component.html',
})
export class AccountRequestComponent {
  private readonly formBuilder = inject(FormBuilder);
  private readonly viewService = inject(ViewService);
  private readonly dialogRef = inject(MatDialogRef);
  readonly data = inject<{ requirement: RequirementIntake | null }>(MAT_DIALOG_DATA);

  form!: FormGroup;

  loading = signal(false);
  submitting = signal(false);
  submitted = signal(false);

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      request: ['', [Validators.required, this.noWhitespaceValidator]],
    });
  }

  public noWhitespaceValidator(control: FormControl) {
    return (control.value || '').trim().length ? null : { whitespace: true };
  }

  async onSubmit() {
    this.submitted.set(true);

    // stop here if form is invalid
    if (this.form.invalid) {
      // TODO: Display validation errors
      return;
    }

    this.submitting.set(true);
    try {
      await firstValueFrom(this.sendRequest());
      this.dialogRef.close();
    } catch (error) {
      console.log(error);
      this.submitting.set(false);
    }
  }

  private sendRequest() {
    const accountRequest: AccountRequest = {
      request: this.form.value.request,
    };
    return this.viewService.accountRequest(accountRequest);
  }

  protected readonly submit = submit;
}
